import { render, staticRenderFns } from "./InvitationList.vue?vue&type=template&id=7ceae18c&"
import script from "./InvitationList.vue?vue&type=script&lang=js&"
export * from "./InvitationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports